var _defs, _polygon, _polygon2, _path, _g, _g2, _polygon3, _rect, _polygon4, _polygon5, _polygon6, _polygon7, _g3, _polygon8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNineteen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f3060;\n      }\n\n      .cls-2 {\n        fill: #d2eefc;\n      }\n\n      .cls-3 {\n        fill: #ccc;\n      }\n\n      .cls-4 {\n        fill: #f0efef;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1027 103.72 1027 788.83 777.25 788.83 817.51 760.28 741.19 706.15 780.17 621.29 687.17 612.93 687.17 612.92 678.8 519.93 593.95 558.9 539.81 482.57 485.67 558.9 400.81 519.93 392.45 612.93 299.45 621.29 338.42 706.15 262.09 760.29 302.35 788.83 52.62 788.83 52.62 246.45 182.08 208.52 197.25 204.08 368.53 153.9 401.05 144.37 539.81 103.72 1027 103.72"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1027 103.72 1027 788.83 777.25 788.83 817.51 760.28 741.19 706.15 780.17 621.29 687.17 612.93 687.17 612.92 678.8 519.93 593.95 558.9 539.81 482.57 539.81 103.72 1027 103.72"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M368.53,103.72l57.09,71.37-57.09,71.37h-171.28l-28.55-71.37,28.55-71.37h171.28Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.62,103.72h144.63v142.73H52.62V103.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M368.53,103.72h171.28v142.73h-171.28V103.72Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M741.19,814.39l36.06-25.56,40.26-28.55-76.32-54.13,38.98-84.86-93-8.36h0s-8.37-93-8.37-93l-84.85,38.97-54.14-76.33-54.14,76.33-84.86-38.97-8.36,93-93,8.36,38.97,84.86-76.33,54.14,40.26,28.54,36.07,25.57-38.94,84.88,92.97,8.37,8.36,93,84.86-38.98,54.14,76.33,54.13-76.33h.01l84.85,38.97,8.37-92.99h0s92.97-8.37,92.97-8.37l-38.95-84.88h0ZM454.17,674.65h57.09v57.09h-57.09v-57.09ZM625.45,845.92h-57.1v-57.09h57.1v57.09ZM539.81,800.65v-.15l-57.21,57.21-40.36-40.36,97.57-97.57,56.96-56.96.07.07.06-.06,40.37,40.36-97.46,97.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 454.17,
    y: 674.65,
    width: 57.09,
    height: 57.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 568.35,
    y: 788.83,
    width: 57.1,
    height: 57.09
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "596.9 662.83 637.27 703.19 539.81 800.65 539.81 800.5 482.6 857.71 442.24 817.35 539.81 719.78 596.77 662.82 596.84 662.89 596.9 662.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "780.17 621.29 687.17 612.93 687.17 612.92 780.17 621.29"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "593.94 961.67 593.95 961.67 539.81 1038 593.94 961.67"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 568.35,
    y: 788.83,
    width: 57.1,
    height: 57.09
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "596.9 662.83 637.27 703.19 539.81 800.65 539.81 719.78 596.77 662.82 596.84 662.89 596.9 662.83"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "777.25 788.83 741.19 814.4 741.19 814.39 777.25 788.83"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "687.17 907.64 780.14 899.28 687.17 907.65 687.17 907.64"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "777.26 788.83 777.25 788.83 817.51 760.28 817.52 760.29 777.26 788.83"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_Website"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "637.13 703.18 539.81 800.5 482.6 857.71 442.24 817.35 539.81 719.78 596.77 662.82 637.13 703.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 568.35,
    y: 788.83,
    width: 57.1,
    height: 57.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 454.17,
    y: 674.65,
    width: 57.09,
    height: 57.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M682.54,217.9h228.37v57.09h-228.37v-57.09Z"
  }))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "637.27 703.19 539.81 800.65 539.81 719.92 596.84 662.89 596.9 662.83 637.27 703.19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNineteen);
export default __webpack_public_path__ + "static/media/nineteen.17928da7993eb4b26e89a575798a4f7d.svg";
export { ForwardRef as ReactComponent };